module.exports = __webpack_public_path__ + "static/media/lor.b79858b5.svg";